/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/*
mutation UpdateGoogleCalendarMutation(
  $input: UpdateGoogleCalendarInput!
) {
  updateGoogleCalendar(input: $input) {
    googleCalendar {
      calendarViewPrivateEvents
      enabledCalendars
      id
    }
  }
}
*/
const node = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input",
            "type": "UpdateGoogleCalendarInput!"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "calendarViewPrivateEvents",
        "storageKey": null
    }, v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "enabledCalendars",
        "storageKey": null
    };
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "UpdateGoogleCalendarMutation",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "UpdateGoogleCalendarPayload",
                    "kind": "LinkedField",
                    "name": "updateGoogleCalendar",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "CalendarIntegration",
                            "kind": "LinkedField",
                            "name": "googleCalendar",
                            "plural": false,
                            "selections": [
                                (v2 /*: any*/),
                                (v3 /*: any*/)
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "UpdateGoogleCalendarMutation",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "UpdateGoogleCalendarPayload",
                    "kind": "LinkedField",
                    "name": "updateGoogleCalendar",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "CalendarIntegration",
                            "kind": "LinkedField",
                            "name": "googleCalendar",
                            "plural": false,
                            "selections": [
                                (v2 /*: any*/),
                                (v3 /*: any*/),
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "id",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "id": null,
            "metadata": {},
            "name": "UpdateGoogleCalendarMutation",
            "operationKind": "mutation",
            "text": "mutation UpdateGoogleCalendarMutation(\n  $input: UpdateGoogleCalendarInput!\n) {\n  updateGoogleCalendar(input: $input) {\n    googleCalendar {\n      calendarViewPrivateEvents\n      enabledCalendars\n      id\n    }\n  }\n}\n"
        }
    };
})();
node.hash = 'e276a3984a4ee25289bc5555ef722d3c';
export default node;
